import { Global, Collection, Jobs } from '@sourceflow-uk/sourceflow-sdk';
// import "@sourceflow-uk/job-search/dist/bundle.css";
// import JobSearch from "@sourceflow-uk/job-search";
import SeoHead from '../../components/SeoHead';

import MainBanner from '../../components/MainBanner';
import AllJobSearch from '../../components/AllJobSearch';
import LatestJobs from '../../components/LatestJobs';

export default function JobsPage({
    global,
    sectorIds,
    all_jobs
}) {
    return (
        <>
            <SeoHead
                page_name={`Job Search | Staffing Agency | US and Canada Staffing | Bartech Staffing`}
                canonical_link={`jobs`}
            />
            <MainBanner
                global={global}
                pathPrefix={`jobs_page.main_banner`}
                customClass={``}
                content={
                    <>
                        <h1>Job Search</h1>
                    </>
                }
                imageURL1={`/site-assets/images/main-banner.jpg`}
                imageALT1={`Main Banner`}
                imageURL2={`/site-assets/images/main-banner-overlay.jpg`}
                imageALT2={`Overlay Main Banner`}
                displayImage1={false}
            />
            <AllJobSearch
                global={global}
                pathPrefix={`jobs_page.all_job_search`}
                customClass={`py-5 grayGradientBg position-relative`}
                sectorIds={sectorIds}
                newsletter_content={
                    <>
                        <h2>Subscribe to our newsletter</h2>
                        <p>up to date with Bartech Staffing</p>
                    </>
                }
                formId={`6f215412-dc0c-4edc-a769-0026b8a05ac6`}
                successPageUrl={'/jobs/subscription-success/'}
            />
            <LatestJobs
                global={global}
                pathPrefix={`jobs_page.latest_jobs`}
                customClass={`py-5`}
                post={all_jobs}
                content={<>
                    <h2>Featured Jobs</h2>
                    <p>Find the best tech and digital career opportunities.</p>
                </>
                }
                buttonTitle={``}
                buttonLink={``}
                swiperID={`latestJobsSwiper`}
            />
        </>
    )
}

export async function getStaticProps({ params }) {
    const global = (await Global()).toJson();

    const sector = await Collection('country')
    const sectorIds = sector
        //Exclude from getting Recruitment Sector value
        // .filter(item => item.id !== '2400a212-abe4-4e55-a0dd-8763dc6140fa')
        .filter(item => item.country.en === 'United Kingdom')
        .map(item => item.id).getItems();


    const all_jobs = (await Jobs())
        .filter(function (job) {
            return (
                job.categories
                    // Pulls Sectors only
                    .find((cat) => cat.id === "0f1839bd-fb9f-48cd-926b-9e180e3c264a" && cat.values.find((x) => x.name === "United Kingdom"))
            );
        })
        .filter(function (job) {
            return (
                (new Date(job?.expires_at)) >= (new Date())
            )
        })
        .getItems().slice(0, 8);

    return {
        props: {
            global,
            sectorIds,
            all_jobs
        }
    };
}

// -- Reference -- //
// https://github.com/sourceflow-uk/components/pkgs/npm/sourceflow-head
// https://github.com/sourceflow-uk/components/pkgs/npm/sourceflowtext

